const scrollTo = ({ id, offSet }: { id: string; offSet: number }) => {
  const element = document.querySelector(id);

  if (element) {
    const y = element.getBoundingClientRect().top + window.scrollY + offSet;

    window.scrollTo({ top: y, behavior: 'smooth' });
  }
};

export default scrollTo;
